import { type FlyoutProps } from "../../../utils/flyout-props";

export function FlyoutPostTitle({ screen }: FlyoutProps) {
  const title = screen.flyout?.post?.title;
  const titleShown = !!screen.flyout?.post?.customData?.flyoutPost?.showTitle;
  const color = screen.flyout?.post?.customData?.primary?.color ?? "#ffffff";

  if (title && titleShown) {
    return (
      <div className="text-5xl font-bold text-center p-4" style={{ color }}>
        {title}
      </div>
    );
  }

  return null;
}
